import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Modal } from "antd";
import "../MortgageCalculators/RateQuote.css";
import "../MortgageCalculators/RateQuoteNew.css";
import "./PPEPricing.css";
import SearchBox from "./components/search/index";
import RightDrawer from "./components/search/rightDrawer";
import { checkAccess } from "../../Auth";
import { UR_Owner } from "../../State";
import Lenders from "../../Management/Lenders";
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

// PPEPricing mirrors the legacy Rates tool's page chrome (RateQuoteNew): a top
// header bar with title + actions, and the #f6f6f6 gray content area
// (.rate-quote-new-content) that the white search/result cards sit on. The
// LO/Borrower version toggle is intentionally omitted — PPE is a single unified
// engine with no separate borrower version. The body reuses a FORKED copy of the
// Rates SearchBox whose fetch points at the new unified pricing endpoint; the
// real Rates tool (MortgageCalculators) is untouched.
export default function PPEPricing() {
  const [params, setParams] = useState({});
  const [rightDrawer, setRightDrawer] = useState(false);
  const [addLenderModal, setAddLenderModal] = useState(false);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    track(STATSIG.COMMON.VIEW, PAGE.RATES, { page: PAGE.RATES })
  }, [])

  return (
    <div className="rate-quote-new ppe-pricing">
      {/* Top menu bar — mirrors the legacy Rates header format. */}
      <Row
        style={{
          borderBottom: "1px solid #DBDCDE",
          height: 62,
          alignItems: "center",
          margin: 0,
        }}
      >
        <Col xs={6} style={{ paddingLeft: 26 }}>
          {!isMobile && (
            <div
              style={{
                fontWeight: 500,
                textAlign: "left",
                fontSize: "18px",
                color: "#222",
              }}
            >
              Rates
            </div>
          )}
        </Col>
        <Col xs={6}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingRight: isMobile ? 0 : 20,
              gap: 8,
            }}
          >
            {checkAccess([UR_Owner]) && (
              <Button
                variant="addLenders"
                className="addLendersBtn addLendersBtn-new"
                onClick={() => {
                  track(STATSIG.RATES.ADD_LENDERS_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                  setAddLenderModal(true)
                }}
              >
                Add lenders
              </Button>
            )}
            <div
              className="rate-quote-new-header-btn cursor-pointer"
              onClick={() => {
                track(STATSIG.RATES.RECENT_SEARCH_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                setRightDrawer(true)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.99951 6.66667V10L11.6662 11.6667M2.54102 9.16672C2.72776 7.33344 3.5829 5.63307 4.94329 4.39003C6.30368 3.14699 8.07409 2.44829 9.91675 2.42725C11.7594 2.4062 13.5453 3.06428 14.9337 4.27592C16.3222 5.48756 17.2159 7.16796 17.4445 8.9965C17.6731 10.825 17.2204 12.6737 16.173 14.1899C15.1255 15.706 13.5566 16.7834 11.7654 17.2166C9.97428 17.6498 8.08636 17.4084 6.46185 16.5384C4.83733 15.6685 3.58995 14.231 2.95768 12.5001M2.54102 16.6667V12.5001H6.70768"
                  stroke="#325CEB"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </Col>
      </Row>

      {/* Scroll area with the gray content background. */}
      <div style={{ height: "calc(100vh - 62px)", overflowY: "scroll" }}>
        <div className="rate-quote-new-content">
          <SearchBox params={params} />
        </div>
      </div>

      <RightDrawer
        isOpen={rightDrawer}
        onClose={() => setRightDrawer(false)}
        onApplyParams={(paramsFromRightDrawer) => {
          setParams(paramsFromRightDrawer);
          setRightDrawer(false);
        }}
      />

      <Modal
        open={addLenderModal}
        onCancel={() => setAddLenderModal(false)}
        centered
        footer={[
          <Button key="back" onClick={() => setAddLenderModal(false)}>
            Cancel
          </Button>,
        ]}
        width={1200}
      >
        <Lenders statsigSource="rates" />
      </Modal>
    </div>
  );
}
